import { render, staticRenderFns } from "./tradeIndia.vue?vue&type=template&id=1e922710&scoped=true"
import script from "./tradeIndia.vue?vue&type=script&lang=js"
export * from "./tradeIndia.vue?vue&type=script&lang=js"
import style0 from "./tradeIndia.vue?vue&type=style&index=0&id=1e922710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e922710",
  null
  
)

export default component.exports